import React from 'react';
import colors, { white } from '../../../theme/colors';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { isDarkMode } from '../../../utils/helpers';

interface Props {
  count: number;
}
const OneTapOfferUnreadBadge: React.FC<Props> = ({ count }) => {
  if (!count || count < 1) {
    return null;
  }

  const theme = isDarkMode() ? 'dark' : 'light';

  return (
    <span
      className="oneTapUnreadOfferBadge"
      style={{
        position: 'absolute',
        top: -13,
        right: -13,
        padding: '4px 7px',
        textAlign: 'center',
        borderRadius: 17,
        backgroundColor: colors[theme].notifications.red,
        color: white,
        fontSize: 11,
        fontWeight: 500,
        minWidth: 10,
      }}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    count: state.unreadOneTapOffersCount.count,
  };
};

export default connect(mapStateToProps, null)(OneTapOfferUnreadBadge);
